import React from "react";
import { Card, Col, Descriptions, Row, Table, Typography } from "antd";
import { getColumnsWithHighlight, getDriverRatesZonesColumns, renderColumn } from "./helper";
import { ellipseText } from "../../common/Common";
import I18n from "../../common/I18n";

const { Text, Paragraph } = Typography;

const currentScreen = window.location.pathname

const renderConfigDetails = (oldConfig, newConfig, type = null) => {
  if(!oldConfig || !newConfig) return null;
  const {
    min_charge_as_base_charge: old_min_charge_as_base_charge,
    break_weight: old_break_weight,
    los_range: old_los_range,
    apply_min_max_charge_on_each_range: old_apply_min_max_charge_on_each_range,
    apply_fuel_surcharge: old_apply_fuel_surcharge,
    weight_units: old_weight_units,
    base_pallets: old_base_pallets,
    multi_stop_min_charge_as_base_charge: old_multi_stop_min_charge_as_base_charge,
    distance_from_location_id: old_distance_from_location_id,
    true_cap: old_true_cap,
    true_cap_value: old_true_cap_value
  } = oldConfig || {};

  const {
    min_charge_as_base_charge: new_min_charge_as_base_charge,
    break_weight: new_break_weight,
    los_range: new_los_range,
    apply_min_max_charge_on_each_range: new_apply_min_max_charge_on_each_range,
    apply_fuel_surcharge: new_apply_fuel_surcharge,
    weight_units: new_weight_units,
    base_pallets: new_base_pallets,
    multi_stop_min_charge_as_base_charge: new_multi_stop_min_charge_as_base_charge,
    distance_from_location_id: new_distance_from_location_id,
    true_cap: new_true_cap,
    true_cap_value: new_true_cap_value
  } = newConfig || {};

  const getStyle = (oldValue, newValue) => {
    if (oldValue !== newValue) {
      return { backgroundColor: "yellow" };
    }
    return {};
  };

  const renderText = (value) => {
    const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(value) ? value : "N/A";

    if (type === "REMOVED") {
      return <Paragraph delete>{displayValue}</Paragraph>;
    }
    return <Text>{ellipseText(displayValue.replace(/_/g, " "),10, true)}</Text>;
  };

  const renderColSpan = currentScreen.includes("accounts")   ? 4   : (new_los_range === "PALLET" ? 4 : 3);

  return (
    <Descriptions size="small" column={{ xl: renderColSpan, lg: renderColSpan, md: 12, sm: 24, xs: 24 }} style={{textAlign: "left" }}>
      <Descriptions.Item label="Base Rate (Min Charge)">
        <span style={getStyle(old_min_charge_as_base_charge, new_min_charge_as_base_charge)}>
          {renderText(new_min_charge_as_base_charge ? "Yes" : "No")}
        </span>
      </Descriptions.Item>
      <Descriptions.Item label="Break Weight">
        <span style={getStyle(old_break_weight, new_break_weight)}>
          {renderText(new_break_weight ? "Yes" : "No")}
        </span>
      </Descriptions.Item>
      <Descriptions.Item label={`${I18n.t('general.short_los')} Range`}>
        <span style={getStyle(old_los_range, new_los_range)}>
          {renderText(new_los_range)}
        </span>
      </Descriptions.Item>
      <Descriptions.Item label="Min-Max/Range">
        <span style={getStyle(old_apply_min_max_charge_on_each_range, new_apply_min_max_charge_on_each_range)}>
          {renderText(new_apply_min_max_charge_on_each_range ? "Yes" : "No")}
        </span>
      </Descriptions.Item>
      <Descriptions.Item label="True Cap">
        <span style={getStyle(old_true_cap, new_true_cap)}>
          {renderText(new_true_cap ? "True" : "False")}
        </span>
      </Descriptions.Item>
      {new_true_cap && <Descriptions.Item label="True Cap Value">
        <span style={getStyle(old_true_cap_value, new_true_cap_value)}>
          {renderText(String(new_true_cap_value))}
        </span>
      </Descriptions.Item>}
      {
        currentScreen.includes("accounts") && (
          <Descriptions.Item label="Distance Metric">
          <span style={getStyle(old_distance_from_location_id, new_distance_from_location_id)}>
            {renderText(new_distance_from_location_id)}
          </span>
        </Descriptions.Item>
        )
      }
      <Descriptions.Item label="Fuel Surcharge">
        <span style={getStyle(old_apply_fuel_surcharge, new_apply_fuel_surcharge)}>

          {renderText(new_apply_fuel_surcharge ? "Yes" : "No")}
        </span>
      </Descriptions.Item>
      {(new_los_range === "WEIGHT" || new_los_range === "WEIGHT_PALLET") && (
        <>
          <Descriptions.Item label="Weight Units">
            <span style={getStyle(old_weight_units, new_weight_units)}>
              {renderText(new_weight_units)}
            </span>
          </Descriptions.Item>
        </>
      )}
      {
        new_los_range === "PALLET" && (
          <>
            <Descriptions.Item label="Pallets">
              <span style={getStyle(old_base_pallets, new_base_pallets)}>
                {renderText(new_base_pallets)}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="Multi-Stop Min Charge">
              <span style={getStyle(old_multi_stop_min_charge_as_base_charge, new_multi_stop_min_charge_as_base_charge)}>
                {renderText(new_multi_stop_min_charge_as_base_charge ? "Yes" : "No")}
              </span>
            </Descriptions.Item>
          </>
        )
      }
    </Descriptions>
  );
};

const renderDriverRateDetails = (oldConfig, newConfig, type = null) => {
  if(!oldConfig || !newConfig) return null;
  const {
    code: old_code,
    name: old_name,
  } = oldConfig || {};

  const {
    code: new_code,
    name: new_name,
  } = newConfig || {};

  const getStyle = (oldValue, newValue) => {
    if (oldValue !== newValue) {
      return { backgroundColor: "yellow" };
    }
    return {};
  }

   const renderText = (value) => {
    const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(value) ? value : "N/A";

    if (type === "REMOVED") {
      return <Paragraph delete>{displayValue}</Paragraph>;
    }
    return <Text>{ellipseText(displayValue.replace(/_/g, " "),10, true)}</Text>;
  };

  return (
    <Descriptions size="small" column={{ xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }} style={{textAlign: "left" }}>
      <Descriptions.Item label="Rate Code">
        {type === "previous" ? (
          renderText(old_code)
        ) : (
          <span style={getStyle(old_code, new_code)}>
            {renderText(new_code)}
          </span>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Rate Name">
        {type === "previous" ? (
          renderText(old_name)
        ) : (
          <span style={getStyle(old_name, new_name)}>
            {renderText(new_name)}
          </span>
        )}
      </Descriptions.Item>
    </Descriptions>
  );
}

const renderOrgRateSheetDetails = (oldConfig, newConfig, type = null) => {
  if (!oldConfig || !newConfig) return null;
  const {
    code: old_code,
    name: old_name,
    route_calculation_type: old_route_calculation_type,
    amount_after_first_pallet: old_amount_after_first_pallet,
    min_charge: old_min_charge,
    max_charge: old_max_charge,
  } = oldConfig || {};

  const {
    code: new_code,
    name: new_name,
    route_calculation_type: new_route_calculation_type,
    amount_after_first_pallet: new_amount_after_first_pallet,
    min_charge: new_min_charge,
    max_charge: new_max_charge,
  } = newConfig || {};

  // Normalized slug for comparisons/display if needed
  const new_route_calculation_type_slug =
    typeof new_route_calculation_type === 'string'
      ? new_route_calculation_type.toLowerCase().replace(/\s+/g, '_')
      : new_route_calculation_type;

  const getStyle = (oldValue, newValue) => {
    if (oldValue !== newValue) {
      return { backgroundColor: "yellow" };
    }
    return {};
  };

  const renderText = (value) => {
    const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(
      value
    )
      ? value
      : "N/A";

    if (type === "REMOVED") {
      return <Paragraph delete>{displayValue}</Paragraph>;
    }
    return (
      <Text>{ellipseText(displayValue.replace(/_/g, " "), 10, true)}</Text>
    );
  };

  return (
    <Descriptions
      size="small"
      column={{ xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}
      style={{ textAlign: "left" }}
    >
      <Descriptions.Item label="Rate Code">
        <span style={getStyle(old_code, new_code)}>{renderText(new_code)}</span>
      </Descriptions.Item>
      <Descriptions.Item label="Rate Name">
        <span style={getStyle(old_name, new_name)}>{renderText(new_name)}</span>
      </Descriptions.Item>
      <Descriptions.Item label="Route Calculation Type">
        <span
          style={getStyle(
            old_route_calculation_type,
            new_route_calculation_type
          )}
        >
          {renderText(new_route_calculation_type)}
        </span>
      </Descriptions.Item>
      {(new_route_calculation_type_slug ===
        "max_b/w_consolidated_pallet_vs_highest_city_price" ||
        new_route_calculation_type_slug === "consolidated_stop_price_by_route") && (
        <Descriptions.Item label="Amount After First Pallet">
          <span
            style={getStyle(
              old_amount_after_first_pallet,
              new_amount_after_first_pallet
            )}
          >
            {renderText(new_amount_after_first_pallet)}
          </span>
        </Descriptions.Item>
      )}
      {new_route_calculation_type_slug === "consolidated_stop_price_by_route" && (
        <>
          <Descriptions.Item label="Min Charge">
            <span style={getStyle(old_min_charge, new_min_charge)}>
              {renderText(new_min_charge)}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="Max Charge">
            <span style={getStyle(old_max_charge, new_max_charge)}>
              {renderText(new_max_charge)}
            </span>
          </Descriptions.Item>
        </>
      )}
    </Descriptions>
  );
};

export const CommonCard = ({ children, minHeight="200px", maxHeight="250px"  }) => (
  <Card
  style={{
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
    marginBottom: "16px",
    padding: "2px",
    minHeight: minHeight,
    maxHeight: maxHeight,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  }}
  >
    {children}
  </Card>
);

export const renderRegularEntry = (changes, _, type) => {
  if (!changes?.length) return null;
  const config = changes[0]?.new_value?.configurations ?? changes[0]?.old_value?.configurations;

  return (
    <CommonCard>
      {renderConfigDetails(config, config, type)}
    </CommonCard>
  );
};

export const renderRegularRateEntry = (changes, _, type) => {
  if (!changes) return null;
  const config = changes?.old_value ?? changes?.new_value;
  const newConfig = changes?.new_value ?? changes?.old_value;

  return (
    <>
      {renderDriverRateDetails(config, newConfig, type)}
    </>
  );
}


export const renderRegularOrgRateEntry = (changes, _, type) => {
  if(!changes?.length) return null;
  const config = changes[0]?.new_value ?? changes[0]?.old_value;

  return (
    <>
      {renderOrgRateSheetDetails(config, config, type)}
    </>
  );
}
 

const renderTable = (dataSource, columns, scrollY = 110) => (
  <Table columns={columns} dataSource={dataSource} pagination={false} bordered scroll={{x:"max-content", y:scrollY}} />
);

export const renderRegularGroup = (changes, _, type, incomingTableColumns) => {
  if (!changes?.length) return null;

  let dataSource = [];
  const incomingData = changes && (changes[0].new_value ?? changes[0].old_value);
  // Check if changes is an array or an object
  if (Array.isArray(incomingData)) {
    dataSource = incomingData
  } else if (typeof incomingData === "object") {
    const value = ['ADDED', 'REMOVED'].includes(type) && incomingData;
    dataSource = [{ ...(value || {}), key: 0 }];
  } else {
    return null;
  }

  return (
    <div className="mb-6">
      {renderTable(dataSource, incomingTableColumns.map((col) => renderColumn(col, type)))}
    </div>
  );
};


export const renderModifiedGroup = (changes, incomingTableColumns = [], screenFrom="") => {
  if (!changes?.length) return null;

  const extractValues = (changes, keyPrefix) =>{
    const incomingData = changes[0][keyPrefix]
    if(Array.isArray(incomingData)){
      return incomingData
    }else{
      return changes
      .filter((change) => change[keyPrefix])
      .map((change, index) => ({
        ...change[keyPrefix],
        key: `${keyPrefix.substring(0, 3)}-${index}`,
      }));
    }
  }

  const oldValues = extractValues(changes, "old_value");
  const newValues = extractValues(changes, "new_value");

  const oldConfig = screenFrom !== "ratesheet" ? oldValues[0]?.configurations || {} : oldValues[0] || {};
  const newConfig = screenFrom !== "ratesheet" ? newValues[0]?.configurations || {} : newValues[0] || {};

  // Get columns - for driverRatesZones, pass the changes data directly
  let oldColumns = incomingTableColumns;
  let newColumns = incomingTableColumns;
  
  if (screenFrom === "driverRatesZones") {
    oldColumns = getDriverRatesZonesColumns(changes, screenFrom, true);
    newColumns = getDriverRatesZonesColumns(changes, screenFrom, false);
  } else {
    newColumns = getColumnsWithHighlight(incomingTableColumns, oldValues, newValues, screenFrom);
  }

  const renderSide = (title, config, newConfig, data, columns) => (
    <Col span={12}>
      <h5
        className="ant-typography ant-typography-sm font-medium mb-2"
        style={{ textAlign: "left", color: "#666", fontWeight: "bold" }}
      >
        {title}
      </h5>
      <CommonCard oldConfig={config} newConfig={newConfig}>
        {_.isEmpty(screenFrom) && renderConfigDetails(config, newConfig) || screenFrom === "ratesheet" && renderOrgRateSheetDetails(config, newConfig)}
        {screenFrom !== "ratesheet" && renderTable(data, columns)}
      </CommonCard>
    </Col>
  );

  return (
    <div className="mb-6">
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        Modified Entries
      </h4>
      <Row gutter={16} type="flex" justify="space-around">
        {renderSide("Previous Entry", oldConfig, oldConfig, oldValues, oldColumns)}
        {renderSide("Modified Entry", oldConfig, newConfig, newValues, newColumns)}
      </Row>
    </div>
  );
};